/** Accept a Lalamove order ID or customer tracking / share URL. */
export function parseLalamoveOrderReference(raw: string): string {
  const text = raw.trim();
  if (!text) return '';

  if (!/^https?:\/\//i.test(text)) {
    return text;
  }

  try {
    const url = new URL(text);
    for (const key of ['orderId', 'order_id', 'id']) {
      const value = url.searchParams.get(key)?.trim();
      if (value) return value;
    }

    const parts = url.pathname.split('/').filter(Boolean);
    const last = parts[parts.length - 1]?.trim();
    if (last && last.length >= 8) return last;
  } catch {
    return text;
  }

  return text;
}
